import { ChartView } from '@/features/ai-agents/chat/MarkdownTableVisualization/types';

export const CHART_COLOR = `#2563eb`;

export const CHART_SERIES_COLORS = [
  `#2563eb`,
  `#dc2626`,
  `#059669`,
  `#d97706`,
  `#7c3aed`,
  `#0891b2`,
  `#db2777`,
  `#4b5563`,
];

export const TABLE_COLUMN_MIN_WIDTH = `15rem`;
export const TABLE_COLUMN_MAX_WIDTH = `24rem`;

export const CHART_VIEWS: { label: string; value: ChartView }[] = [
  { label: `Line`, value: `line` },
  { label: `Bar`, value: `bar` },
  { label: `Pie`, value: `pie` },
];
